import angular from "angular";
import { vsName as reportingModuleName } from "../../reporting";

import {
  vsServiceName as projectCostServiceName,
  ProjectCostServiceProvider,
  ProjectCostServiceRun,
} from "./ProjectCostService";

import { vsModuleName as ProjectCostSharedConfigModule } from "./configs/module";
export const vsModuleName = "SlotTrak.ProjectCost.Shared";

angular
  .module(vsModuleName, [reportingModuleName, ProjectCostSharedConfigModule, "ui.router"])
  .provider(projectCostServiceName, ProjectCostServiceProvider)
  .run(ProjectCostServiceRun);
